import fromUnixTime from 'date-fns/fromUnixTime';
import format from 'date-fns/format';

// UTF-8 byte order mark. Excel (the default tool on Windows/pt-BR) only detects
// UTF-8 when the file starts with this BOM; without it, accented characters are
// rendered as mojibake (e.g. "Classificação" instead of "Classificação").
const UTF8_BOM = String.fromCharCode(0xfeff);

export const downloadCsvFile = (fileName, content) => {
  const blob = new Blob([UTF8_BOM, content], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.setAttribute('download', fileName);
  link.setAttribute('href', url);
  link.click();
  return link;
};

export const generateFileName = ({ type, to, businessHours = false }) => {
  let name = `${type}-report-${format(fromUnixTime(to), 'dd-MM-yyyy')}`;
  if (businessHours) {
    name = `${name}-business-hours`;
  }
  return `${name}.csv`;
};
